export function updateCounter(counterEl, newCount) {
	if (!counterEl) return
	counterEl.dataset.count = newCount
    console.log('Updating counter:', counterEl, newCount)
	const currentCountEl = counterEl.querySelector('.current-count')
	if (currentCountEl) {
		currentCountEl.textContent = newCount
	}
}
